export default __webpack_public_path__ + "static/media/ic_default_user.cd712255.svg";